// Bank numbers, checked the way the database checks them (ledger._iban_ok,
// _bic_ok) so mistakes are caught while typing, not on save.

const compact = (s: string) => s.replace(/\s/g, '').toUpperCase();

/** IBAN with valid check digits (mod 97); Irish and UK IBANs must also be 22 characters. */
export function ibanOk(iban: string): boolean {
  const s = compact(iban);
  if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/.test(s)) return false;
  if ((s.startsWith('IE') || s.startsWith('GB')) && s.length !== 22) return false;
  const digits = (s.slice(4) + s.slice(0, 4)).replace(/[A-Z]/g, (c) => String(c.charCodeAt(0) - 55));
  let m = 0;
  for (let i = 0; i < digits.length; i += 7) m = Number(String(m) + digits.slice(i, i + 7)) % 97;
  return m === 1;
}

export function bicOk(bic: string): boolean {
  return /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(compact(bic));
}

/** IE29 AIBK 9311 5212 3456 78 */
export function formatIban(iban: string): string {
  return compact(iban).replace(/(.{4})/g, '$1 ').trim();
}

/** 20-00-00; anything that isn't six digits is returned as typed. */
export function formatSortCode(s: string): string {
  const d = s.replace(/\D/g, '');
  return d.length === 6 ? `${d.slice(0, 2)}-${d.slice(2, 4)}-${d.slice(4)}` : s;
}
